<mat-form-field [appearance]="appearance || 'legacy'" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    class="input"
    type="text"
    [mask]="mask"
    [pattern]="'^[0-9a-zA-Z ]+([\.]?[0-9a-zA-Z ]+)*$'"
    [patterns]="patterns"
    [formControl]="form"
    [specialCharacters]="specialCharacters"
    [dropSpecialCharacters]="false"
    [placeholder]="placeholder"
    [required]="required"
    [readonly]="readonly"
    (focusout)="onTouched()"
  />

  <fb-anex [style.margin-right.px]="0" *ngIf="suffix" matSuffix [config]="suffix" position="end"></fb-anex>
</mat-form-field>
